import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addRewardTier from './addRewardTier';
import { pageSize } from '@/mixins/index';
export default {
  name: "rewardRule",
  components: {
    addRewardTier: addRewardTier
  },
  mixins: [pageSize],
  data: function data() {
    return {
      paramsData: {
        page: 1,
        page_size: 10,
        reward_group_id: ''
      },
      tableData: [],
      total: 0,
      rewardList: []
    };
  },
  created: function created() {
    this.getList();
    this.getRewardData();
  },
  methods: {
    getRewardData: function getRewardData() {
      var _this = this;

      this.$api.rewardList({
        page_size: -1
      }).then(function (res) {
        if (res.code == 200) {
          _this.rewardList = res.data;
        }
      });
    },
    getList: function getList() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this2.paramsData.page = page;

                _this2.$api.rewardTierList(_this2.paramsData).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data.data;
                    data.forEach(function (item) {
                      item.groupName = item.group.name ? item.group.name : '';
                    });
                    _this2.tableData = data;
                    _this2.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该奖励规则, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$api.rewardTierDelete({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message.success("删除成功!");

                    _this3.getList(_this3.paramsData.page);
                  } else {
                    _this3.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};